import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _65407a9c = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _01743079 = () => interopDefault(import('../../../pages/my-account/index.vue' /* webpackChunkName: "pages/my-account/index" */))
const _92077f36 = () => interopDefault(import('../../../pages/login/forgot-password.vue' /* webpackChunkName: "pages/login/forgot-password" */))
const _4d5f3829 = () => interopDefault(import('../../../pages/login/reset-password.vue' /* webpackChunkName: "pages/login/reset-password" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _e91ed76c = () => interopDefault(import('~/plugins/Cruxtify/pages/single.vue' /* webpackChunkName: "" */))
const _25340fc0 = () => interopDefault(import('~/plugins/Cruxtify/pages/list.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/login",
    component: _65407a9c,
    name: "login"
  }, {
    path: "/my-account",
    component: _01743079,
    name: "my-account"
  }, {
    path: "/login/forgot-password",
    component: _92077f36,
    name: "login-forgot-password"
  }, {
    path: "/login/reset-password",
    component: _4d5f3829,
    name: "login-reset-password"
  }, {
    path: "/",
    component: _0547af50,
    name: "index"
  }, {
    path: "/movies/:id",
    component: _e91ed76c,
    meta: {"modelType":"Movie"},
    name: "Movie edit"
  }, {
    path: "/movies",
    component: _25340fc0,
    meta: {"modelName":"Movie","modelType":"Movie"},
    name: "Movie list"
  }, {
    path: "/movie-nights/:id",
    component: _e91ed76c,
    meta: {"modelType":"MovieNight"},
    name: "MovieNight edit"
  }, {
    path: "/movie-nights",
    component: _25340fc0,
    meta: {"modelName":"MovieNight","modelType":"MovieNight"},
    name: "MovieNight list"
  }, {
    path: "/reviews/:id",
    component: _e91ed76c,
    meta: {"modelType":"Review"},
    name: "Review edit"
  }, {
    path: "/reviews",
    component: _25340fc0,
    meta: {"modelName":"Review","modelType":"Review"},
    name: "Review list"
  }, {
    path: "/screenshots/:id",
    component: _e91ed76c,
    meta: {"modelType":"Screenshot"},
    name: "Screenshot edit"
  }, {
    path: "/screenshots",
    component: _25340fc0,
    meta: {"modelName":"Screenshot","modelType":"Screenshot"},
    name: "Screenshot list"
  }, {
    path: "/themes/:id",
    component: _e91ed76c,
    meta: {"modelType":"Theme"},
    name: "Theme edit"
  }, {
    path: "/themes",
    component: _25340fc0,
    meta: {"modelName":"Theme","modelType":"Theme"},
    name: "Theme list"
  }, {
    path: "/freekz/:id",
    component: _e91ed76c,
    meta: {"modelType":"User"},
    name: "User edit"
  }, {
    path: "/freekz",
    component: _25340fc0,
    meta: {"modelName":"User","modelType":"User"},
    name: "User list"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
